export default "__VITE_ASSET__Drr1FUKL__"